import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { ScenariosBetaApi } from 'src/api';
import { ScenariosBetaStatusResponse } from 'src/api/scenariosBeta/types';
import { ROUTES } from 'src/constants/routes.const';
import useSafePush from 'src/hooks/useSafePush';

export function useScenariosBetaStatus() {
  const { asPath } = useRouter();
  const { safePush } = useSafePush();

  const { data: status, isFetched: isReady } = useQuery<ScenariosBetaStatusResponse>({
    queryKey: ['scenariosBetaStatus'],
    queryFn: () => {
      return ScenariosBetaApi.getScenariosBetaStatus();
    },
  });

  const isJoined = status?.isJoined;
  useEffect(() => {
    if (isJoined === false && asPath !== ROUTES.dashboard) {
      void safePush(ROUTES.dashboard);
    }
  }, [isJoined, asPath, safePush]);

  if (!isReady) return { shouldStay: false, isJoined };

  if (!status?.isJoined) {
    return { shouldStay: true, isJoined };
  }

  return { shouldStay: true, isJoined };
}
